import { Box, BoxProps, ColorOptions, IconButton, ModBox, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'

interface KeyValueInterface {
  data: Array<any>
}

export const KeyValue = ({ data }: KeyValueInterface) => {
  const dataPairs = Object.entries(data)
  return dataPairs.map(([key, value]) => {
    if (value === '') {
      return null
    }
    let text = value
    let color = 'BLACK_75'
    if (typeof value === 'object') {
      text = value?.text
      color = value?.color
    }
    return (
      <Box {...styles.individualRow}>
        <Box {...styles.widthAdjuster}>
          <TextNew {...styles.keyText} title={key} />
        </Box>
        <SpacerNew size={20} direction="horizontal" />
        <Box {...styles.widthAdjuster} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
          <TextNew {...styles.value} color={color as ColorOptions} title={text ?? ''} />
          <ModBox ml={8} show={value?.onPress && value?.iconId ? true : false}>
            <IconButton id={value?.iconId} size={18} color={'PRIMARY'} onPress={value?.onPress} />
          </ModBox>
        </Box>
      </Box>
    )
  })
}

const styles = {
  individualRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    pv: 8,
  } as BoxProps,
  keyText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'SECONDARY_GREY',
    textAlign: 'left',
  } as TextNewProps,
  value: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_75',
    textAlign: 'right',
  } as TextNewProps,
  widthAdjuster: {
    flex: 1,
  } as BoxProps,
}
